import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'

export const EMAIL_VERIFY_REQUEST = 'EMAIL_VERIFY_REQUEST'
export const doEMAIL_VERIFY_REQUEST = createDoRequestAction(EMAIL_VERIFY_REQUEST)

export const requestEmailVerifyActionCreators = {
  doEMAIL_VERIFY_REQUEST,
}

export function* requestEmailVerify({payload, setRequestResult}: any): SagaIterator {
  debug('saga*emailVerifyRequest')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        email: v.string().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: EMAIL_VERIFY_REQUEST,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {email} = payload

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/identity-email-verify-request`,
    data: {
      email,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)

    return yield put(
      doREQUEST_ERROR(
        {
          fromType: EMAIL_VERIFY_REQUEST,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/identity-email-verify-request',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: EMAIL_VERIFY_REQUEST,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* requestEmailVerifySaga() {
  yield takeEvery(EMAIL_VERIFY_REQUEST, requestEmailVerify)
}
